export default function useMonthlyPlanningHooks() {
  const monthlySell = [
    {
      keyName: 'jan',
      name: 'MONTHLY_SELL.JANUARY_PLAN_SELLING',
      value: 4,
    },
    {
      keyName: 'feb',
      name: 'MONTHLY_SELL.FABRUARY_PLAN_REVENUE',
      value: 4,
    },
    {
      keyName: 'march',
      name: 'MONTHLY_SELL.MARCH_PLAN_SELLING',
      value: 5,
    },
    {
      keyName: 'april',
      name: 'MONTHLY_SELL.APRIL_PLAN_SELLING',
      value: 4,
    },
    {
      keyName: 'may',
      name: 'MONTHLY_SELL.MAY_PLAN_SELLING',
      value: 4,
    },
    {
      keyName: 'june',
      name: 'MONTHLY_SELL.JUNE_PLAN_SELLING',
      value: 5,
    },
    {
      keyName: 'july',
      name: 'MONTHLY_SELL.JULY_PLAN_SELLING',
      value: 4,
    },
    {
      keyName: 'aug',
      name: 'MONTHLY_SELL.AUGUST_PLAN_SELLING',
      value: 4,
    },
    {
      keyName: 'sept',
      name: 'MONTHLY_SELL.SEPTEMBER_PLAN_SELLING',
      value: 5,
    },
    {
      keyName: 'oct',
      name: 'MONTHLY_SELL.OCTOBER_PLAN_SELLING',
      value: 4,
    },
    {
      keyName: 'nov',
      name: 'MONTHLY_SELL.NOVEMBER_PLAN_SELLING',
      value: 4,
    },
    {
      keyName: 'dec',
      name: 'MONTHLY_SELL.DECEMBER_PLAN_SELLING',
      value: 5,
    },
    {
      keyName: 'totalPWS',
      name: 'MONTHLY_SELL.PLANNED_WEEK_SALE',
      value: 0,
    },
  ];
  const caluculateTotalPWS = async (state) => {
    let totalPws = 0;
    const requiredObj = state?.planSelling;
    for (const keys in requiredObj) {
      if (requiredObj[keys] === true) {
        const monthValue = monthlySell.find((o) => o.keyName === keys);
        if (monthValue) {
          totalPws += monthValue.value;
        }
      }
    }
    return totalPws;
  };

  return { caluculateTotalPWS, monthlySell };
}
